import { Box, Typography } from "@mui/material";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

const stats = [
  { icon: AutoStoriesOutlinedIcon, value: "18.000+", label: "Artigos científicos indexados" },
  { icon: ForumOutlinedIcon, value: "10.000+", label: "Consultas realizadas" },
  { icon: AccessTimeOutlinedIcon, value: "< 3s", label: "Tempo médio de resposta" },
  { icon: PublicOutlinedIcon, value: "24/7", label: "Disponibilidade contínua" },
];

export default function StatsSection() {
  return (
    <section className="relative z-10 px-6 md:px-12 pb-20 md:pb-28 border-t border-white/10 pt-16 md:pt-20">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto text-center">
        {stats.map((stat) => (
          <div key={stat.label} className="flex flex-col items-center">
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "16px",
                background: "rgba(255, 137, 4, 0.12)",
                border: "1px solid rgba(255, 137, 4, 0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <stat.icon sx={{ fontSize: 26, color: "#FF8904" }} />
            </Box>
            <Typography
              sx={{
                color: "#ffffff",
                fontWeight: 800,
                fontFamily: "Oxanium, sans-serif",
                fontSize: { xs: "1.5rem", md: "2rem" },
                marginBottom: "6px",
              }}
            >
              {stat.value}
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.9rem" }}>
              {stat.label}
            </Typography>
          </div>
        ))}
      </div>
    </section>
  );
}
